/* ============
 * App Module State
 * ============
 *
 */

export default {
  appSections: {
    traditional: 'traditional',
    clo: 'clo'
  },
  section: null,
  selectedDeal: null,
  // merchant locations sorted by deals
  merchantLocations: {}
}



// WEBPACK FOOTER //
// ./src/app/store/modules/app/state.js